import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, Circle, X, Rocket } from "lucide-react";

const STEPS = [
  ["logo", "Adaugă un logo"],
  ["member", "Invită primul membru"],
  ["message", "Trimite primul mesaj"],
  ["bug", "Raportează primul bug cu /bug"],
  ["atena", "Întreab-o pe Atena ceva"],
];

// Every step is derived from what is in the workspace, so it ticks itself.
export default function OnboardingChecklist({ workspaceId, canDismiss }) {
  const [state, setState] = useState(null);

  const load = useCallback(() => {
    if (!workspaceId) return;
    api.get("/onboarding", { params: { workspace_id: workspaceId } })
      .then((r) => setState(r.data))
      .catch(() => setState(null));
  }, [workspaceId]);

  useEffect(() => { load(); }, [load]);

  const dismiss = async () => {
    setState(null);
    try {
      await api.post("/onboarding/dismiss", null, { params: { workspace_id: workspaceId } });
    } catch { /* it comes back on the next load, which is harmless */ }
  };

  if (!state || state.dismissed || state.complete) return null;
  const done = STEPS.filter(([k]) => state.steps[k]).length;

  return (
    <div className="mx-3 mt-4 border border-line/10 bg-surface-2" data-testid="onboarding-checklist">
      <div className="px-3 py-2 flex items-center gap-2 border-b border-line/10">
        <Rocket className="w-3.5 h-3.5 text-brand" />
        <span className="label-tiny">PRIMII PAȘI {done}/{STEPS.length}</span>
        {canDismiss && (
          <button
            type="button" onClick={dismiss} data-testid="onboarding-dismiss"
            aria-label="Ascunde lista" className="ml-auto text-fg/30 hover:text-fg"
          ><X className="w-3 h-3" /></button>
        )}
      </div>
      <ul className="p-3 space-y-1.5">
        {STEPS.map(([key, label]) => (
          <li key={key} className="flex items-center gap-2 text-xs">
            {state.steps[key]
              ? <CheckCircle2 className="w-3.5 h-3.5 text-brand flex-shrink-0" />
              : <Circle className="w-3.5 h-3.5 text-fg/30 flex-shrink-0" />}
            <span className={state.steps[key] ? "text-fg/40 line-through" : "text-fg/80"}>{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
